<template>
	<div class="mr-12 connections width-100 height-100">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between pt-7 pr-6 pb-4">
			<div>
				<div class="title-text">Connections</div>
				<div class="description-text">Your features can use these connections to perform actions in your apps</div>
			</div>
			<div v-if="isSupported && canCreateNewConnection">
				<AnemicButton :loading="connectDialog" :disabled="!canCreateNew" @click="connectProfile" class="new-button">
					Add Connection
				</AnemicButton>
				<ProfileConnectNewDialog :showDialog.sync="connectDialog" :preselectApp="preselectApp" :projectId="currentProjectId" />
			</div>
		</div>
		<template v-if="isSupported">
			<Col v-if="isLoading" class="flex-centerize height-100">
				<AppLoader class="mt-4" size="18px" color="#101840" />
			</Col>
			<div v-else-if="isNoResults" class="height-100 flex-centerize">
				<h2 class="reg">No connections found</h2>
			</div>
			<div v-else class="overflow-y-auto display-flex flex-column width-100 px-6 list-container">
				<div :key="i" v-for="(section, i) in connectionsBySections">
					<SettingsTable :title="section.title" :subTitle="section.subTitle" :sourceList="section.sourceList">
						<template v-slot:item="{ item }">
							<SettingsProfilesListItem
								:key="item.id"
								class="mb-2 px-2"
								:profileData="item"
								:alwaysShowProjectChip="section.alwaysShowProjectChip"
							/>
						</template>
					</SettingsTable>
				</div>
			</div>
		</template>
		<div v-else class="height-100 flex-centerize">
			<h2 class="reg">Ply doesn't support connections for this app yet.</h2>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import AppService from '@/utils/AppService';
import SettingsTable from '@/views/settings/SettingsTable';
import SettingsProfilesListItem from '@/components/Settings/SettingsProfilesListItem';
import ProfileConnectNewDialog from '@/components/Settings/ProfilesConnectNewDialog.vue';
import { getProjectCredentials } from '@/store/modules/credentials/actions';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { isLoadingUserData } from '@/store/modules/auth/getters';

export default {
	name: 'Connections',
	props: {
		preselectApp: { type: Object },
		connectionsBySections: { type: Array },
		currentProjectId: { type: [String, Number] },
		canCreateNew: { type: Boolean, default: true },
	},
	components: {
		SettingsTable,
		ProfileConnectNewDialog,
		SettingsProfilesListItem,
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, isLoadingUserData }),
		isNoResults() {
			return this.connectionsBySections.every((section) => (section.sourceList || []).length === 0);
		},
		isSupported() {
			if (!this.preselectApp) {
				return true;
			}
			return AppService.doesRequiresAuth(this.preselectApp);
		},
		canCreateNewConnection() {
			return this.hasAccountPermission(AccountPermissions.CreateWorkflows);
		},
		isLoading() {
			if (this.isNoResults) {
				return this.isLoadingUserData;
			} else {
				// if we have results, we don't want to show the loading indicator
				return false;
			}
		},
	},
	methods: {
		...mapActions([getProjectCredentials.fullPath]),
		connectProfile() {
			this.connectDialog = true;
		},
	},
	data: () => ({
		connectDialog: false,
	}),
};
</script>

<style scoped lang="scss">
.connections {
	height: 100%;
	padding-bottom: 150px;
}
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: #a3a3a3;
	text-align: left;
	letter-spacing: 0px;
}
.list-container {
	height: 100%;
}
</style>
